module.exports = __webpack_public_path__ + "static/media/img_mobile_offer.1808dbdc.png";